import { useState } from "react";

export default function useShare() {
  const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);

  const handleShareDialogOpen = () => {
    setIsShareDialogOpen(true);
  };

  const handleShareDialogCancel = () => {
    setIsShareDialogOpen(false);
  };

  return {
    isShareDialogOpen,
    handleShareDialogOpen,
    handleShareDialogCancel,
  };
}
